import { SET_CLIENT_PUBLICATION } from "../actions/action-types.js";

export default function clientPublication(state = {}, {type, payload}) {
    switch (type) {
        case SET_CLIENT_PUBLICATION:
            return (state = payload)
        default:
            return state
    }
}